module.exports = __webpack_public_path__ + "static/media/letterHeadBottom.28ed0952.jpg";